module.exports = __webpack_public_path__ + "static/viz-wiz-36ee931f817741e76890aa7a34a82d04.png";